import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useStore } from 'hooks';
import { VALIDATION } from 'helpers/constants';
import { Button, ButtonClose } from 'components/ui/form';
import { Input } from 'components/ui/formik';
import { ConsigneeService } from 'services';
import styles from './consignee-catalog.module.scss';

const ConsigneeCatalogValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .required(...VALIDATION.REQUIRED),
  address: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING)),
  inn: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .required(...VALIDATION.REQUIRED),
  codeGd: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING)),
  code: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING)),
});

const ConsigneeCatalog = ({ edit, onClose }) => {
  const { setUser, setLoading } = useStore();

  const initialValues = {
    name: edit ? (edit.name || '') : '',
    address: edit ? (edit.address || '') : '',
    inn: edit ? (edit.inn || '') : '',
    codeGd: edit ? (edit.codeGd || '') : '',
    code: edit ? (edit.code || '') : '',
  };

  const onSubmit = async (values) => {
    const consigneeService = new ConsigneeService({ setUser });
    setLoading(true);

    if (edit) {
      await consigneeService.updateConsignee(edit.id, { ...values });
    } else {
      await consigneeService.createConsignee({ ...values });
    }

    setLoading(false);
    onClose(true);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={ConsigneeCatalogValidationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={styles.consignee} autoComplete="off">
          <div className={styles.main}>
            <div className={styles.title}>
              {edit ? 'Изменение ' : 'Создание '}
              грузополучателя
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input label="Наименование компании" name="name" placeholder="Введите наименование компании" />
              </div>
              <div className={styles.field}>
                <Input label="Адрес грузополучателя" name="address" placeholder="Введите полный адрес" />
              </div>
              <div className={styles.field}>
                <Input label="УНП" name="inn" placeholder="Введите УНП" />
              </div>
              <div className={styles.field}>
                <Input label="Ж/Д код грузополучателя" name="codeGd" placeholder="Введите Ж/Д код" />
              </div>
              <div className={styles.field}>
                <Input label="Код внутренний" name="code" placeholder="Введите код внутренний" />
              </div>
            </div>
          </div>
          <div className={styles.buttons}>
            <div>
              <Button type="submit">{edit ? 'Изменить' : 'Добавить'}</Button>
            </div>
            <div>
              <ButtonClose onClick={() => onClose(false)}>{edit ? 'Закрыть' : 'Отменить'}</ButtonClose>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ConsigneeCatalog;
